import React, { forwardRef, useEffect, useState } from 'react';
import {
  Hidden, Typography, Zoom
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import CustomNavLink from 'components/CustomNavLink/CustomNavLink';
import PAGES from 'common/pages';
import { useLocation } from 'react-router';
import useUser from 'hooks/useUser';

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    backgroundColor: theme.palette.background.paper
  },
  button: {
    color: 'white',
    padding: '10px 32px',
    textTransform: 'none',
    letterSpacing: 0,
    // width: '100%',
    height: '100%',
    // fontWeight: theme.typography.fontWeightMedium,
    '&:hover': {
      color: theme.palette.secondary.main,
    }
  },
  active: {
    color: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  underline: {
    border: '2px solid white',
    width: '70%',
  },
}));

const NavButton = forwardRef((props, ref) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    if (location.pathname.startsWith(props.to)) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [location, props]);
  return (
    <div
      ref={ref}
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', height: 'calc(100%)'
      }}
    >
      <span style={{ flex: 1 }} />
      <Typography
        {...props}
      >
        {props.children}
      </Typography>
      <span style={{ flex: 1 }} />
      {isActive ? (
        <Zoom in unmountOnExit>
          <div className={classes.underline} />
        </Zoom>
      )
        : <div style={{ border: `2px solid ${theme.palette.primary.main}`, width: '70%' }} />}
    </div>
  );
});

const TopbarNav = () => {
  const classes = useStyles();
  const [{ data }] = useUser();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
      <Hidden smDown>
        <NavButton
          activeClassName={classes.active}
          className={classes.button}
          component={CustomNavLink}
          to={PAGES.INTERFACE_STATUS}
        >
          Interface Status
        </NavButton>
        {(data?.is_staff || data?.is_superuser) && (
          <>
            <NavButton
              activeClassName={classes.active}
              className={classes.button}
              component={CustomNavLink}
              to={PAGES.SWITCHES}
            >
              Switches
            </NavButton>
            <NavButton
              activeClassName={classes.active}
              className={classes.button}
              component={CustomNavLink}
              to={PAGES.MODEMS}
            >
              Modems
            </NavButton>
            <NavButton
              activeClassName={classes.active}
              className={classes.button}
              component={CustomNavLink}
              to={PAGES.RADIOS}
            >
              Radios
            </NavButton>
          </>
        )}
      </Hidden>
    </div>
  );
};
export default TopbarNav;
